export function variablePlugin($R) {
  mainVariable($R);
  variableAddClass($R);
}

function mainVariable($R) {
  $R.add('plugin', 'variable', {
    translations: {
      en: {
        "change": "Change",
        "variable": "Variable",
        "variable-select": "Please, select a variable"
      }
    },
    modals: {
      'variable': ''
    },
    init: function (app) {
      this.app = app;
      this.lang = app.lang;
      this.opts = app.opts;
      this.toolbar = app.toolbar;
      this.component = app.component;
      this.insertion = app.insertion;
      this.inspector = app.inspector;
      this.selection = app.selection;
    },

    // public
    start: function () {
      if (!this.opts.variables) return;

      const obj = {
        title: this.lang.get('variable'),
      };

      const variables = {};
      this.opts.variables.map((item, index) => {
        Object.assign(variables, {
          [`item${index}`]: {
            title: item[0],
            args: item[1],
            api: 'plugin.variable.insert'
          }
        });
      });

      const $button = this.toolbar.addButton('variable', obj);
      $button.setTitle('Tags');
      $button.setDropdown(variables);
    },
    insert: function(value) {
      const $variable = this.component.create('variable');
      $variable.html(value);

      this.insertion.insertRaw($variable);
    },

    // private
    _toggle: function (e) {
      var $item = $R.dom(e.target);

      this.app.api('plugin.variable.insert', $item);
    }
  });
}

function variableAddClass($R) {
  $R.add('class', 'variable.component', {
    mixins: ['dom', 'component'],
    init: function (app, el) {
      this.app = app;
      this.utils = app.utils;

      // init
      return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    // public
    getData: function () {
      return {
        type: this._getType()
      };
    },

    // private
    _init: function (el) {
      el = el || '<span>';

      this.parse(el);
      this._initWrapper();
    },
    _getType: function () {
      var text = this.text().trim();

      return this.utils.removeInvisibleChars(text);
    },
    _initWrapper: function () {
      this.addClass('redactor-component');
      this.attr({
        'data-redactor-type': 'variable',
        'tabindex': '-1',
        'contenteditable': false
      });
    }
  });
}
